module.exports = __webpack_public_path__ + "static/media/photo 1 - Version 2.3742e235.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/photo 1 - Version 2.JPG
// module id = 192
// module chunks = 0